import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import {
  doOtpResendRequest,
  doResetPasswordOtpRequest,
  doSendMergeOtpRequest,
  doUpdateWithOtpRequest,
} from '../../../../store/action/auth';
import Ref from '../../../../ui-core/Ref';
import { SEGMENT_EVENTS, trackEvent } from '../../../../utils/Segment';
import { grecaptcha } from '../../../../services/recaptcha';
import { getItem } from '../../../../utils/cache';
import { MODAL_TYPE } from '../../../../constants/app';
import {
  createNotification,
  NOTIFICATION_TYPE,
} from '../../../../services/Notification';

const Counter = props => {
  const {
    postData,
    otp,
    setOtp,
    setOtpDisabled,
    fromPage,
    handleModalState = () => {},
    incorrectCount = 0,
    setIncorrectCount = () => {},
    inputRef = null,
    setOtpError = () => {},
  } = props;
  const dispatch = useDispatch();
  const [counter, setCounter] = useState(60);
  const resetEmail = JSON.parse(getItem('resetDetails'))?.email;
  const isPhoneLogin = getItem('isPhoneLogin');
  const mergeEmail = JSON.parse(getItem('mergeEmailDetail'))?.email;

  useEffect(() => {
    if (incorrectCount === 3) {
      setOtpDisabled(true);
      setCounter(0);
    }
  }, [incorrectCount]);

  const handleOtpResend = e => {
    e.preventDefault();
    // Remove error class
    otp?.forEach((input, index) => {
      inputRef?.current[index]?.classList?.remove('error');
    });
    setOtpError(false); // Reset error
    grecaptcha.execute(token => {
      trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
        button_title: 'Resend Verification Code',
        page: props.page || 'Home Page',
        section_title: 'Enter Code Modal',
      });

      if (fromPage === 'reset-otp') {
        dispatch(
          doResetPasswordOtpRequest({
            data: resetEmail,
            callback: () => {
              handleModalState(MODAL_TYPE.RESET_OTP);
              setCounter(60); // reset timer
              setOtp(new Array(4).fill(''));
              setOtpDisabled(false); // re-enable OTP input
              setIncorrectCount(0);
            },
          }),
        );
      } else if (isPhoneLogin === 'true' && mergeEmail) {
        dispatch(
          doSendMergeOtpRequest({
            data: {
              type: 'email',
              email: mergeEmail,
            },
            callback: () => {
              // handleModalState(MODAL_TYPE.EMAIL_OTP);
              setCounter(60);
              setOtp(new Array(4).fill(''));
              setOtpDisabled(false);
            },
          }),
        );
      } else if (fromPage === 'otp') {
        // Try to get phone details from localStorage if postData is empty
        const phoneDetails = JSON.parse(getItem('PhoneDetails') || '{}');
        const mergePhoneDetail = JSON.parse(
          getItem('mergePhoneDetail') || '{}',
        );

        const countryCode =
          postData?.country_code ||
          phoneDetails?.country_code ||
          mergePhoneDetail?.country_code;
        const mobile =
          postData?.mobile || phoneDetails?.mobile || mergePhoneDetail?.mobile;

        if (!countryCode || !mobile) {
          console.error('No phone data available for OTP resend');
          createNotification({
            type: NOTIFICATION_TYPE.ERROR,
            message: 'Phone number information is missing. Please try again.',
          });
          return;
        }
        // if user phone number is already verified
        if (getItem('isAlreadyHavePhoneVerified')) {
          dispatch(
            doOtpResendRequest({
              data: {
                country_code: countryCode,
                mobile: mobile,
                token,
              },
              callback: () => {
                setCounter(60); // reset timer
                setOtp(new Array(4).fill(''));
                setOtpDisabled(false); // re-enable OTP input
              },
            }),
          );
        } else {
          // if user phone number is not already verified
          dispatch(
            doUpdateWithOtpRequest({
              data: {
                country_code: countryCode,
                mobile: mobile,
              },
              callback: () => {
                setCounter(60);
                setOtp(new Array(4).fill(''));
                setOtpDisabled(false);
              },
            }),
          );
        }
      } else {
        dispatch(
          doUpdateWithOtpRequest({
            data: {
              ...postData,
            },
            callback: () => {
              setCounter(60); // reset timer
              setOtp(new Array(4).fill(''));
              setOtpDisabled(false); // re-enable OTP input
            },
          }),
        );
        // dispatch(
        //   doOtpResendRequest({
        //     data: { ...postData, token },
        //     page: props.page,
        //     callback: () => {
        //       debugger
        //       setCounter(60); // reset timer
        //       setOtp(new Array(4).fill(''));
        //       setOtpDisabled(false); // re-enable OTP input
        //     },
        //   }),
        // );
      }
    });
  };

  useEffect(() => {
    if (counter > 0) {
      setOtpDisabled(false); // Enable OTP input during countdown
      const timeout = setTimeout(() => {
        setCounter(prev => prev - 1);
      }, 1000);
      return () => clearTimeout(timeout);
    } else {
      setOtpDisabled(true); // Disable OTP input when timer finishes
    }
  }, [counter]);

  return (
    <div className="text-center counter">
      {counter > 0 ? (
        <p>
          Resend Verification Code in{' '}
          <span style={{ color: '#13BFB8' }}>
            00:{String(counter).padStart(2, '0')}
          </span>
        </p>
      ) : (
        <Ref class="Resend-otp" text="Resend Code" onClick={handleOtpResend} />
      )}
    </div>
  );
};

Counter.propTypes = {
  page: PropTypes.string,
  postData: PropTypes.shape({
    mobile: PropTypes.string,
    country_code: PropTypes.string,
    otp: PropTypes.string,
  }),
  otp: PropTypes.array,
  setOtp: PropTypes.func,
  setOtpDisabled: PropTypes.func,
  fromPage: PropTypes.string,
  handleModalState: PropTypes.func,
  incorrectCount: PropTypes.number,
  setIncorrectCount: PropTypes.func,
  inputRef: PropTypes.any,
  setOtpError: PropTypes.func,
};

export default Counter;
